import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock-upgrade";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import {
  STORAGE_AUTH_TOKEN,
  STORAGE_RECOVERY_TOKEN,
} from "../constants/variables";

// Hooks
import useQueryParam from "./useQueryParam";

// Utils
import { setLocalStorageItem } from "../utils/localStorage";
import { useDialogWindowStore } from "../stores/dialogWindow";

let timeout: string | number | NodeJS.Timeout | undefined;

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const popupName = useQueryParam(GET_PARAMS.POPUP);
  const [mountedPopup, setMountedPopup] = useState(popupName);

  const location = useLocation();
  const { search } = useLocation();
  const navigate = useNavigate();
  const setIsOpen = useDialogWindowStore((state) => state.setIsOpen);
  const isOpened = Boolean(popupName);

  useEffect(() => {
    if (popupName) {
      setIsOpen(true);
      /*
                Когда человек переходит по ссылке с попапом из-вне,
                то он не может закрыть попап, так как нет истории на сайте.
                Для этого мы проверяем стейт в location (при каждом navigate мы проставляем state)
                Если его нет, то мы редиректим на страницу без попапа и открываем попап заново
            */

      // для восстановления пароля надо из присланной ссылки достать токен и записать в LocalStorage.
      const searchParams = new URLSearchParams(search);
      const params: Record<string, string> = {};
      // eslint-disable-next-line
      // @ts-ignore
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }
      if (
        params.token &&
        params.popup !== GET_POPUP_TYPES.popup.depositResult &&
        params.popup !== GET_POPUP_TYPES.popup.recoveryComplete
      ) {
        setLocalStorageItem(STORAGE_AUTH_TOKEN, params.token);
      }
      if (
        params.token &&
        params.popup === GET_POPUP_TYPES.popup.recoveryComplete
      ) {
        setLocalStorageItem(STORAGE_RECOVERY_TOKEN, params.token);
      }
      if (!location.state) {
        navigate(location.search, { replace: true });
      }
      // eslint-disable-next-line no-unused-expressions
      timeout && clearTimeout(timeout);
      setMountedPopup(popupName);
    } else {
      timeout = setTimeout(() => {
        setMountedPopup(null);
      }, 10);
    }
    return () => {
      // eslint-disable-next-line no-unused-expressions
      timeout && clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popupName]);

  useEffect(() => {
    const element: HTMLDivElement = document.querySelector(
      "#root",
    ) as HTMLDivElement;
    if (isOpened) {
      disableBodyScroll(element, {
        allowTouchMove: () => true,
      });
    } else {
      enableBodyScroll(element);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpened]);

  return { mountedPopup, isOpened };
};
